export const DEFAULT_FIELDS = {
  DEAL_DATE: 'deal_date',
  NAME: 'name',
  DEPT: 'dept',
  EX_ITEM: 'ex_item',
  QUANTITY: 'quantity',
  UNIT: 'unit_value',
  AMOUNT: 'total_value',
  TAX_CATEGORY: 'dr_excise',
  INVOICE_KIND: 'invoice_kind',
  TAX_AMOUNT: 'excise_value',
  WITHHOLDING_TAX_CHECK: 'has_withholding_income_tax',
  WITHHOLDING_TAX_AMOUNT: 'withholding_income_tax_value',
  MEMO: 'memo',
  PROJECT: 'project_code',
  CR_ITEM: 'cr_item',
  CR_SUB_ITEM: 'cr_sub_item',
  CURRENCY: 'currency',
  JPY_RATE: 'jpyrate',
} as const;

export const TAX_RELATED_DEFAULT_FIELDS: string[] = [
  DEFAULT_FIELDS.UNIT,
  DEFAULT_FIELDS.AMOUNT,
];

export const DETAIL_ONLY_DEFAULT_FIELDS: string[] = [
  DEFAULT_FIELDS.UNIT,
  DEFAULT_FIELDS.QUANTITY,
  DEFAULT_FIELDS.MEMO,
];
